import { useAuthStore } from '@/stores/authStore'

/**
 * Custom hook to access company details from the central store
 * @returns {Object} Company details and related state
 */
export const useCompanyDetails = () => {
  const { 
    companyDetails, 
    isLoadingCompanyDetails, 
    fetchCompanyDetails,
    companyUrl 
  } = useAuthStore()

  return {
    companyDetails,
    isLoadingCompanyDetails,
    fetchCompanyDetails,
    companyUrl,
    // Helper methods for common company detail access based on actual API response
    getCompanyName: () => companyDetails?.name || 'Unknown Company',
    getCompanyLogo: () => companyDetails?.logo,
    getCompanyId: () => companyDetails?.id,
    getCompanyUrl: () => companyDetails?.company_url,
    getColorCode: () => companyDetails?.color_code,
    getCreatedAt: () => companyDetails?.created_at,
    getUpdatedAt: () => companyDetails?.updated_at,
    // Template purchase status helpers
    hasFoodTemplates: () => companyDetails?.food_templates_purchased === true,
    hasExerciseTemplates: () => companyDetails?.exercise_templates_purchased === true,
    hasMealTemplates: () => companyDetails?.meal_templates_purchased === true,
    hasRecipes: () => companyDetails?.recipes_purchased === true,
    hasExercisePlanTemplates: () => companyDetails?.exercise_plan_templates_purchased === true,
    hasNutritionProgramTemplates: () => companyDetails?.nutrition_program_templates_purchased === true,
    // Purchase dates
    getFoodTemplatesPurchaseDate: () => companyDetails?.food_templates_purchased_at,
    getExerciseTemplatesPurchaseDate: () => companyDetails?.exercise_templates_purchased_at,
    getMealTemplatesPurchaseDate: () => companyDetails?.meal_templates_purchased_at,
    getRecipesPurchaseDate: () => companyDetails?.recipes_purchased_at,
    getExercisePlanTemplatesPurchaseDate: () => companyDetails?.exercise_plan_templates_purchased_at,
    getNutritionProgramTemplatesPurchaseDate: () => companyDetails?.nutrition_program_templates_purchased_at,
    // Check if company details are available
    hasCompanyDetails: () => !!companyDetails,
  }
}